<template>
  <div class="layout" v-bind:class="{hideSidebar: isCollapse}">
    <div class="menu">
      <el-scrollbar wrap-class="scrollbar-wrapper">
          <h1 class="system" v-if="!isCollapse">
            <img src="//img.pipacoding.com/assets/fe-agent-client/logo.png">
            繁星联盟
          </h1>
          <h1 class="systemText" v-else>繁星<br />联盟</h1>
          <el-menu
            :collapse="isCollapse"
            :default-active="activeMenu"
            background-color="#304156"
            text-color="#dee4eb"
            :unique-opened="true"
            v-bind:class="{activeWidth: !isCollapse}"
            class="el-menu-vertical-demo"
            :collapse-transition="false"
          >
            <sidebar-item :isCollapse="isCollapse"  v-for="(route) in routesConfig" :key="route.path" :route="route" :base-path="route.path"/>
          </el-menu>
      </el-scrollbar>
    </div>
    <app-main :isCollapse="isCollapse" @fold="fold" />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import AppMain from './appMain'
import SidebarItem from './SidebarItem'

export default {
  name: 'Home',
  components: { AppMain, SidebarItem },
  data () {
    return {
      isCollapse: false,
      route: this.$route,
      cachedViews: []
    }
  },
  computed: {
    ...mapGetters([
      'roles',
      'routesConfig'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    fold () {
      this.isCollapse = !this.isCollapse
    },
    isPower (powerCode) {
      if (powerCode === ' ') return true
      if (this.roles.indexOf(powerCode) !== -1) return true
      else return false
    }
  }
}
</script>

<style lang="less" scoped>
.mr10 {
  margin-right: 10px;
}
.system, .systemText{
  color: white;
  vertical-align: middle;
  margin: 20px 0 20px 20px;
  font-family: "Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: 600;
}
.system{
  font-size: 20px;
  img{
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
    height: 30px;
  }
}
.systemText{
  font-size: 14px;
}
</style>
